import React,{ useState, useEffect } from 'react';
import { useAuth } from '../useAuth'
import { Button, Checkbox, Form, Input, Image } from 'antd';
import { useNavigate } from "react-router-dom";
import logo from '../assets/images/conjurorlogo.png'


export const Login = () => {

  const [loginFailed, setLoginFailed] = useState(false)
  const auth = useAuth();
  let navigate = useNavigate();

  console.log(auth)
  const onFinish = (values) => {
    // console.log(useAuth())
    console.log('Success:', values.researchCode);

    return auth.signin(values.researchCode, ()=>{navigate('/')}, (e)=>{setLoginFailed(true);})
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
  <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',  // Center horizontally
        justifyContent: 'center',  // Center vertically
        height: '100vh',  // Full viewport height
        textAlign: 'center',  // Center text inside the container
      }}
    >
  <Image src={logo}
    width={500}
    preview={false}/>
  <Form
    name="basic"
    labelCol={{
      span: 8,
    }}
    wrapperCol={{
      span: 16,
    }}
    style={{
      maxWidth: 600,
    }}
    initialValues={{
      remember: true,
    }}
    onFinish={onFinish}
    onFinishFailed={onFinishFailed}
    autoComplete="off"
  >
    <Form.Item
      label="Access Code"
      name="researchCode"
      rules={[
        {
          required: true,
          message: 'Please input a valid access code!',
        },
      ]}
    >
      <Input />
    </Form.Item>

    <Form.Item
      wrapperCol={{
        offset: 8,
        span: 16,
      }}
    >
      {loginFailed ? 'Please try again':''}
      <br/>
      <Button type="primary" htmlType="submit">
        Submit
      </Button>
    </Form.Item>
  </Form>
{/*  <h3>
  Need an access code? Find out more <a href="https://docs.google.com/forms/d/e/1FAIpQLSdCe0GGHoyXCqYCt8U32BRo151xaiPMUH5Y9HqaqkTsZndvCg/viewform?usp=sf_link">here</a>
  </h3>*/}
  </div>
);}